import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { gql } from '@src/lib/gql';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
export const useCourseToolbar = (pathnames: string[]) => {
  const router = useRouter();
  const result = useMemo(() => {
    const isRouteMatch = (pattern: string) => {
      // Replace wildcard patterns with regex patterns
      const regexPattern = pattern.replace(/\/\[\w+\]/g, '/[^/]+') // Replace dynamic segments like [contentTrackSlug]
      .replace(/\*/g, '.*') // Replace * with .*
      .replace(/\/\.\*$/, '(/.*)?'); // Make trailing wildcard optional

      // console.log('Generated regex:', '^' + regexPattern + '$') // Testing the regex pattern
      // console.log('Current path:', router.asPath) // log the current path

      const regex = new RegExp('^' + regexPattern + '$');
      return regex.test(router.asPath);
    };
    return pathnames.some(isRouteMatch);
  }, [pathnames?.join(';'), router.asPath]);
  return result;
};

// COURSE STUFF

export const contentTrackStepQuery = () => gql`
  query ($contentTrackSlug: String, $contentTrackSectionSlug: String, $contentTrackStepSlug: String) {
    contentTrackSteps(
      where: {
        parentContentTrackSection: {
          slug: $contentTrackSectionSlug
          parentContentTrack: { slug: $contentTrackSlug }
        }
        slug: $contentTrackStepSlug
      }
      first: 1
    ) {
      id
      title
      slug
      body
      video {
        id
        sourceUrl
        playbackDurationInSeconds
        playbackStartInSeconds
        playbackEndInSeconds
      }
      parentContentTrackSection {
        id
        title
        slug
        parentContentTrack {
          id
          title
          type
          slug
        }
      }
    }
  }
`;

// Used for StepNavigator

export const useContentTrackStep = (contentTrackSlug, contentTrackSectionSlug, contentTrackStepSlug) => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = contentTrackStepQuery();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== contentTrackSectionSlug || $[2] !== contentTrackSlug || $[3] !== contentTrackStepSlug) {
    t1 = {
      variables: {
        contentTrackSlug,
        contentTrackSectionSlug,
        contentTrackStepSlug
      }
    };
    $[1] = contentTrackSectionSlug;
    $[2] = contentTrackSlug;
    $[3] = contentTrackStepSlug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const query = useQuery(t0, t1);
  const contentTrackStep = query.data?.contentTrackSteps[0];
  const contentTrackSection = contentTrackStep?.parentContentTrackSection;
  const contentTrack = contentTrackSection?.parentContentTrack;
  let t2;
  if ($[5] !== contentTrack || $[6] !== contentTrackSection || $[7] !== contentTrackStep || $[8] !== query) {
    t2 = {
      query,
      contentTrackStep,
      contentTrackSection,
      contentTrack
    };
    $[5] = contentTrack;
    $[6] = contentTrackSection;
    $[7] = contentTrackStep;
    $[8] = query;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};

// VIDEO STUFF

export const videoListQuery = (videoListSlug: string | string[]) => {
  const slug = Array.isArray(videoListSlug) ? videoListSlug[0] : videoListSlug;
  return useQuery(videoList(), {
    variables: {
      videoListSlug: slug
    }
  });
};
export const videoList = () => gql`
  query ($videoListSlug: String) {
    videoList(where: { slug: $videoListSlug }) {
      id
      slug
      title
      videos {
        id
        title
        slug
        durationInSeconds
      }
    }
  }
`;